import { AddOutlined } from '@mui/icons-material'
import { Button, Stack } from '@mui/material'
import type { FC } from 'react'
import { Link } from 'react-router-dom'

export const OutputButtonRow: FC = () => {
  return (
    <Stack direction="row" justifyContent="flex-end" sx={{ px: 2, py: 2 }}>
      <Link to="/reportExports/new">
        <Button variant="contained" color="primary" startIcon={<AddOutlined />}>
          新規でレポート出力
        </Button>
      </Link>
    </Stack>
  )
}
